<template>
    <li
    v-if="spindex.length != 0"
    class="spindex-box">
        <div class="title">
            <h1>APP活跃</h1>
            <el-link
            type="primary"
            :underline="false"
            :href="'http://www.100ec.cn/Index/appRank.html'"
            target="_blank">
            更多></el-link>
        </div>

        <div class="con spindex">
            <el-table
            :data="spindex"
            :stripe = "iftrue"
            border
            style="width: 100%">
				<el-table-column
				prop="ranking"
				label="排名">
				</el-table-column>
               <el-table-column
                prop="time_m"
                label="时间">
                </el-table-column>
                <el-table-column
                prop="app_name"
                label="应用名">
                </el-table-column>
                <el-table-column
                prop="type_name"
                label="行业">
                </el-table-column>
                <el-table-column
                prop="uv"
                label="活跃人数(万)">
                </el-table-column>
                <el-table-column
                prop="rank_ratio"
                label="环比增幅（%）">
                </el-table-column>
                <!-- <el-table-column
                prop="grade"
                label="评级">
                </el-table-column> -->
            </el-table>
        </div>
    </li>
</template>

<script>
export default {
    name: 'spindex',
    data() {
        return {
            filter: [
                // '快手'
            ],
            spindex: [],
			iftrue: true,
        }
    },
    created() {
        if(this.filter.includes(this.$route.query.name)) {
            return
        }
// + this.$route.query.name
        axios.post('/Index/url_json', {
			url: 'http://bjx.iimedia.cn/applicationRankSearch',
			appName: this.$route.query.name,
		})
		
        .then(res => {
			this.spindex = res.data
            for(let i in res.data) {
                if(res.data[i].length != 0) {
					res.data[i].ranking = i-0+1
					res.data[i].uv = parseFloat(res.data[i].uv/10000).toFixed(2)
					res.data[i].rank_ratio = parseFloat(res.data[i].rank_ratio).toFixed(2) 
                }
            }
            this.spindex = res.data
        })
    }
}
</script>